/**
 *  Documentos (documentos/*) → /api/v1/document-folders
 *  Forma vieja: carpeta {IdFolder, NombreFolder, IdProyecto, NombreProyecto};
 *  documento {IdDocumento, NombreDocumento, Ruta, IdFolder, NombreFolder, path}.
 *  `path` es lo que abre la vista; ahora es la URL firmada de v1 (1 h).
 */
import api from '../apiV1';
import { fail, done, list } from './index';

const toFolder = (f) => ({
   IdFolder: f.id,
   NombreFolder: f.name,
   IdProyecto: f.project ? f.project.id : null,
   NombreProyecto: f.project ? f.project.name : null,
});

const projectId = (v) => (v ? Number(v) : null);

export default {
   'GET documentos/get/folders': async () => {
      const res = await api.get('document-folders');
      if (!res.ok) return fail(res);
      return list((res.data || []).map(toFolder));
   },

   'POST documentos/create/folder': async (data) =>
      done(await api.post('document-folders', { name: data.NombreFolder || '', projectId: projectId(data.IdProyecto) })),

   // Status 0 es la baja; con cualquier otro se actualiza nombre y proyecto.
   'POST documentos/update/folder': async (data) => {
      if (Number(data.Status) === 0) return done(await api.del(`document-folders/${data.IdFolder}`));
      return done(
         await api.put(`document-folders/${data.IdFolder}`, {
            name: data.NombreFolder || '',
            projectId: projectId(data.IdProyecto),
         })
      );
   },

   'GET documentos/get': async (data) => {
      const res = await api.get(`document-folders/${data.IdFolder}/documents`);
      if (!res.ok) return fail(res);
      return list(
         (res.data || []).map((d) => ({
            IdDocumento: d.id,
            NombreDocumento: d.name,
            IdFolder: d.folderId,
            path: d.url || '',
         }))
      );
   },

   // El componente adjunta el PDF como primer archivo (file_1 en Koa).
   'POSTFILE documentos/create': async (data, { files }) => {
      const file = files.find(Boolean);
      if (!file) return { error: true, message: 'Selecciona un archivo PDF.' };
      const res = await api.upload('POST', `document-folders/${data.IdFolder}/documents`, [['file', file]], {
         name: data.NombreDocumento || '',
      });
      return done(res);
   },

   // Status 0 es la baja; si no, renombra o mueve a otra carpeta.
   'POST documentos/update': async (data) => {
      const path = `document-folders/${data.IdFolder}/documents/${data.IdDocumento}`;
      if (Number(data.Status) === 0) return done(await api.del(path));
      return done(
         await api.put(path, {
            name: data.NombreDocumento || '',
            folderId: Number(data.IdFolderNuevo || data.IdFolder),
         })
      );
   },
};
